module.exports = __webpack_public_path__ + "static/media/frequent-destination.adef733a.svg";